













import Vue from 'vue'

export default Vue.extend({
  name: 'SystemNeo',
  props: {
    init: Boolean,
    sleeping: Boolean
  },
  methods: {
    setVh () {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    }
  },
  mounted () {
    document.documentElement.style.setProperty('--dpr', `${window.devicePixelRatio}`);
    this.setVh();
    window.addEventListener('resize', this.setVh);
  }
});
